module.exports = __webpack_public_path__ + "static/media/BA_Lessing_Schrift.35879791.png";